import Panel from "@/shared/components/Panel";
import {
	BrainIcon,
	FileIcon,
	LanPendingIcon,
	MonitorCellphoneStarIcon,
} from "@/shared/dynamicImports";
import {
	colorAccent,
	colorBackground,
	colorBorder,
	colorHover,
	colorText,
	colorTextAdditional,
} from "@/utils/palette";
import styled from "styled-components";

const GpuOneHardwareSpecifications = ({
  gpu,
  totalStorage,
  storageDisks,
  networkInterfaces,
}) => {
  return (
    <Panel lg={6} xl={6} md={12} sm={12} title="Hardware Specifications">
      <SpecsGrid>
        <SpecCard>
          <SpecIcon>
            <MonitorCellphoneStarIcon color={colorAccent} size={32} />
          </SpecIcon>
          <SpecContent>
            <SpecTitle>CPU</SpecTitle>
            <SpecValue>{gpu.cpu_type}</SpecValue>
            <SpecDetail>{gpu.total_cpu_cores} cores</SpecDetail>
          </SpecContent>
        </SpecCard>
        <SpecCard>
          <SpecIcon>
            <BrainIcon color={colorAccent} size={32} />
          </SpecIcon>
          <SpecContent>
            <SpecTitle>Memory</SpecTitle>
            <SpecValue>{gpu.total_memory} GB</SpecValue>
            <SpecDetail>RAM</SpecDetail>
          </SpecContent>
        </SpecCard>
        <SpecCard>
          <SpecIcon>
            <FileIcon color={colorAccent} size={32} />
          </SpecIcon>
          <SpecContent>
            <SpecTitle>Storage</SpecTitle>
            <SpecValue>{totalStorage.toFixed(1)} GB</SpecValue>
            <SpecDetail>{storageDisks.length} disks</SpecDetail>
          </SpecContent>
        </SpecCard>
        <SpecCard>
          <SpecIcon>
            <LanPendingIcon color={colorAccent} size={32} />
          </SpecIcon>
          <SpecContent>
            <SpecTitle>Network</SpecTitle>
            <SpecValue>{networkInterfaces.length}</SpecValue>
            <SpecDetail>interfaces</SpecDetail>
          </SpecContent>
        </SpecCard>
      </SpecsGrid>
    </Panel>
  );
};

export default GpuOneHardwareSpecifications;

const SpecsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

const SpecCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 100%;
  background: ${colorBackground};
  border-radius: 5px;
  border: 1px solid ${colorBorder};
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  min-height: 75px;
  aspect-ratio: 1;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    background: ${colorHover};
  }
`;

const SpecIcon = styled.div`
  font-size: 2rem;
  margin-bottom: 10px;
`;

const SpecContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  text-align: center;
`;

const SpecTitle = styled.span`
  font-size: 0.9rem;
  color: ${colorTextAdditional};
  font-weight: 500;
`;

const SpecValue = styled.span`
  font-size: 1.2rem;
  font-weight: 700;
  color: ${colorText};
`;

const SpecDetail = styled.span`
  font-size: 0.8rem;
  color: ${colorTextAdditional};
`;
